import { resolvePlan } from "@/components/ImportEvernoteExtras";
import { EvernoteGuideButton } from "@/components/EvernoteGuide";

function PlanRow({ nb, count, plan, setPlan, myCookbooks, i }) {
  const { title, renamed, match, hasMatch } = resolvePlan(nb, plan, myCookbooks);
  const set = (patch) => setPlan((p) => ({ ...p, [nb]: { ...(p[nb] || {}), ...patch } }));
  return (
    <div className="flex flex-wrap items-center gap-3 py-2" data-testid={`notebook-plan-row-${i}`}>
      <span className="text-xs font-bold text-slate-500 w-40 truncate" title={nb}>{nb} ({count})</span>
      <input value={plan[nb]?.title ?? nb} onChange={(e) => set({ title: e.target.value })} aria-label={`Cookbook name for ${nb}`}
             className="text-sm rounded-lg border border-slate-300 px-3 py-1.5 w-56 focus:ring-2 focus:ring-rf-amber" data-testid={`notebook-plan-name-${i}`} />
      <span className="text-xs text-slate-600 flex-1 min-w-[200px]" data-testid={`notebook-plan-status-${i}`}>
        {match ? <>Adds to your existing <b>“{match.title}”</b> — recipes already in it are skipped.</>
          : renamed ? "New cookbook (renamed)." : "New private cookbook."}
      </span>
      {match && <button type="button" onClick={() => set({ optOut: true })} className="text-xs font-bold text-rf-orange" data-testid={`notebook-plan-new-${i}`}>Make a new cookbook instead</button>}
      {!match && hasMatch && !renamed && <button type="button" onClick={() => set({ optOut: false })} className="text-xs font-bold text-rf-orange" data-testid={`notebook-plan-existing-${i}`}>Add to my existing “{title}”</button>}
    </div>
  );
}

export function NotebookPlan({ notebooks, counts, plan, setPlan, myCookbooks, user }) {
  return (
    <div className="px-5 py-3 bg-amber-50/70 border-b border-amber-200 text-sm text-slate-700" data-testid="import-split-note">
      <p className="mb-1">
        {user ? "Tapping Save puts" : "After you sign in, Save puts"} {notebooks.length === 1 ? "your notebook into a cookbook of the same name" : "each notebook into its own cookbook"}.
        {" "}{notebooks.length === 1 ? "If you already have a cookbook with that name, the recipes join it" : "A notebook with the same name as one of your cookbooks joins it"};
        rename below to make a new cookbook instead (a renamed one always becomes new). Your Evernote tags become categories.{" "}
        <EvernoteGuideButton label="How this works" testid="guide-open-preview" />
      </p>
      <div className="divide-y divide-amber-200/70">
        {notebooks.map((nb, i) => <PlanRow key={nb} nb={nb} i={i} count={counts[nb] || 0} plan={plan} setPlan={setPlan} myCookbooks={user ? myCookbooks : []} />)}
      </div>
    </div>
  );
}
